export function continueWithOptionalPricingAddToCart({
  sendAddToCartEvent,
  hasTrackedAddToCartRef,
  trackPricingAddToCart,
  next,
}: {
  sendAddToCartEvent: boolean | undefined;
  hasTrackedAddToCartRef: { current: boolean };
  trackPricingAddToCart(): Promise<void>;
  next(): void;
}) {
  const trackedRef = hasTrackedAddToCartRef;
  if (sendAddToCartEvent && !hasTrackedAddToCartRef.current) {
    trackedRef.current = true;
    void trackPricingAddToCart()
      .catch(() => {
      // never block section navigation for tracking
      });
  }

  next();
}
